import React, { useState } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

import { zxcvbn } from "@zxcvbn-ts/core";

const AddEmail = ({ data, updateEmails, closePopup, updateError }) => {
    const [emailData, setEmailData] = useState({
        newEmail: "",
        password: "",
    });
    const currSiteUrl = data.currSiteUrl;
    const cleanCurrSiteUrl = currSiteUrl?.replace(/^https?:\/\//, "");
    const [passwordStrength, setPasswordStrength] = useState({
        score: 0,
        label: "",
        color: "",
    });
    const [fieldErrors, setFieldErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showCopyConfirmation, setShowCopyConfirmation] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const validateStrongPassword = (password) => {
        // const errors = {};
        // if (password.length < 8) {
        //     errors.length = "Password must be at least 8 characters long.";
        // }
        // if (!/[A-Z]/.test(password)) {
        //     errors.uppercase =
        //         "Password must contain at least one uppercase letter.";
        // }
        // if (!/[a-z]/.test(password)) {
        //     errors.lowercase =
        //         "Password must contain at least one lowercase letter.";
        // }
        // if (!/[0-9]/.test(password)) {
        //     errors.number = "Password must contain at least one number.";
        // }
        // if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        //     errors.special =
        //         "Password must contain at least one special character.";
        // }
        // return errors;

        const pwdResult = {};
        const result = zxcvbn(password);
        const score = result.score; // 0–4
        const percent = (score / 4) * 100;
        pwdResult.score = percent;
        if(percent < 90){
            pwdResult.error = 'Weak Password. Please use a strong Password!';
        }

        return pwdResult;
        
    };

    const getPasswordStrength = (score) => {
        let label = "Weak";
        let color = "red";
        if (score >= 90) {
            label = "Strong";
            color = "green";
        }
        return { score, label, color };
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEmailData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === "password") {
            const passwordErrorsScore = validateStrongPassword(value);
            const strength = getPasswordStrength(passwordErrorsScore.score);
            setPasswordStrength(strength);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const copyPasswordToClipboard = () => {
        navigator.clipboard.writeText(emailData.password).then(() => {
            setShowCopyConfirmation(true);
            setTimeout(() => setShowCopyConfirmation(false), 2000); 
        });
    };

    const handleSubmit = async () => {
        setLoading(true);
        updateError("");
        setFieldErrors({});

        if(!emailData.newEmail) {
            setFieldErrors((prev) => ({
                ...prev,
                newEmail: "This field is required.",
            }));
            setLoading(false);
            return;
        }

        const passwordErrors = validateStrongPassword(emailData.password);
        // if (Object.keys(passwordErrors).length > 0) {
        if (passwordErrors.error) {
            setFieldErrors((prev) => ({
                ...prev,
                password: passwordErrors.error
            }));
            setLoading(false);
            return;
        }

        try {
            const currSiteUrl = data.currSiteUrl;
            const currSiteId = data.currSiteId;
            const cleanCurrSiteUrl = currSiteUrl?.replace(/^https?:\/\//, "");
            const emailToAdd = emailData.newEmail;
            const password = emailData.password;

            if (emailToAdd && password && cleanCurrSiteUrl && currSiteId) {
                const response = await apiInstance.post(
                    "/dashboard/emails/add",
                    {
                        emailData: {
                            siteId: currSiteId,
                            emailAddress: emailToAdd,
                            password: password,
                            domain: cleanCurrSiteUrl,
                        },
                    }
                );

                const emails = response.data.emails.emails;
                const emailsLimit = response.data.emails.allowedCount;
                emails && updateEmails && updateEmails(emails, emailsLimit);
                closePopup();
            } else {
                alert("Missing website or password or email address!");
            }
        } catch (error) {
            console.error(`Error:`, error);
            if (error.response) {
                if (
                    error.response.status === 400 &&
                    error.response.data.fieldErrors
                ) {
                    setFieldErrors(error.response.data.fieldErrors);
                } else {
                    updateError(error.response.data?.message || 'Something went wrong, please try again later');
                }
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mjs-pp">
            <h2>Add New Email</h2>
            <form>
                <div className="mjs-input-field">
                    <label htmlFor="siteName">
                        Email Address
                    </label>
                    <div className="mjs-email-new-sec">
                        <input
                            type="text"
                            placeholder="Enter email"
                            name="newEmail"
                            value={emailData.newEmail}
                            onChange={handleInputChange}
                        />
                        <span>@{cleanCurrSiteUrl}</span>
                    </div>
                    {fieldErrors.newEmail && (
                        <span className="mjs-error">
                            {fieldErrors.newEmail}
                        </span>
                    )}
                </div>

                <div className="mjs-input-field">
                    <label htmlFor="password">Password</label>
                    <div className="mjs-password-input-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter password"
                            name="password"
                            value={emailData.password}
                            onChange={handleInputChange}
                        />
                        <span className="mjs-password-actions">
                            {showCopyConfirmation && (
                                <span><i className="fa-solid fa-check" style={{color: 'green'}}></i></span>
                            )}
                            <span onClick={copyPasswordToClipboard}><i className="fa-solid fa-copy"></i></span>  
                            <span onClick={togglePasswordVisibility}>
                                <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                            </span>                          
                        </span>
                    </div>

                    {fieldErrors.password && (
                        <span className="mjs-error">
                            {fieldErrors.password}
                        </span>
                    )}

                    {emailData.password && (
                        <div className="mjs-password-strength">
                            <div className="mjs-strength-bar">
                                <div
                                    className="mjs-strength-fill"
                                    style={{
                                        width: `${passwordStrength.score}%`,
                                        backgroundColor: passwordStrength.color,
                                    }}
                                />
                            </div>
                            <span
                                className="mjs-strength-label"
                                style={{ color: passwordStrength.color }}
                            >
                                {passwordStrength.label}
                            </span>
                        </div>
                    )}

                </div>
            </form>

            <div className="mjs-form-actions">
                {loading && <i className="fa-solid fa-spinner fa-spin"></i>}
                <Button name="Add" eventHandler={handleSubmit} />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
        </div>
    );
};

export default AddEmail;
